import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImagesModule } from '@app/shared/components/images/images.module';

import { SliderComponent } from './slider.component';

@NgModule({
  imports: [CommonModule, ImagesModule],
  exports: [SliderComponent],
  declarations: [SliderComponent]
})
export class SliderModule {}
